<template>
  <div class="seat-container" v-loading="loading">
    <!-- <h3>43人座</h3> -->
    <div class="outsideDiv" style="display: flex; justify-content: center">
      <div class="leftContainer" ref="capture" id="leftContainer">
        <div class="rowDiv">
          <table style="font-size: 14px">
            <tr>
              <td>
                <div class="leftrow">一排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">二排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">三排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">四排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">五排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">六排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">七排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">八排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">九排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">十排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">十一排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="leftrow">十二排</div>
              </td>
            </tr>
          </table>
        </div>

        <div class="seatDiv" id="seatDiv">
          <table style="width: 100%">
            <tr v-for="(s, sindex) in seatAry" :key="sindex">
              <!-- <td v-if="sindex == 6">
                <div class="noseat leftline">安全門</div>
              </td> -->

              <template v-for="(seat, seatIndex) in s">
                <td
                  v-if="seat.display"
                  :key="seatIndex"
                  :rowspan="
                    (!seat.isSeat && sindex == 0 && seatIndex == 4) ||
                    (sindex == 7 && seatIndex == 4)
                      ? 2
                      : 1
                  "
                >
                  <!-- 非座位 -->
                  <div
                    :class="{
                      noseat: !seat.isSeat,
                      rightRowSpan:
                        (sindex == 0 && seatIndex == 4) || (sindex == 7 && seatIndex == 4),
                      leftline: sindex == 6 && seatIndex == 0,
                    }"
                  >
                    {{
                      !seat.isSeat
                        ? sindex == 0 && seatIndex == 4
                          ? '前門'
                          : sindex == 7 && seatIndex == 4
                            ? '後門'
                            : sindex == 6 && seatIndex == 0
                              ? '安全門'
                              : ''
                        : ''
                    }}
                  </div>

                  <!-- 有人座 -->
                  <div
                    class="seat"
                    :position="[sindex, seatIndex]"
                    v-if="seat.isSeat && seat.user && seat.user.name"
                    :info="JSON.stringify(seat.user)"
                  >
                    <span
                      :info="JSON.stringify(seat.user)"
                      class="drag-source"
                      draggable="true"
                      :id="'drag-source-' + seat.user.id"
                      :position="[seat.position[0], seat.position[1]]"
                      style="white-space: pre-wrap"
                    >
                      {{ seat.user.name.replace(/-/g, '\n') }}
                    </span>
                  </div>
                  <!-- 沒人座 -->
                  <div
                    class="seat"
                    v-if="seat.isSeat && !seat.user"
                    :position="[sindex, seatIndex]"
                  ></div>
                </td>
              </template>
            </tr>
          </table>
        </div>

        <div class="rowDiv">
          <table style="font-size: 14px">
            <tr>
              <td>
                <div class="rightrow"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow">二排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow">三排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow">四排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow">五排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow">六排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow">九排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow">十排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow">十一排</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="rightrow">十二排</div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="sourceDiv">
        <!-- <h3 style="">旅客名單</h3> -->
        <div class="source-container">
          <div v-for="(group, index) in groupedArray" :key="index">
            <div
              class="source-title"
              @click="
                groupKeyName == group.key ? (groupKeyName = null) : (groupKeyName = group.key)
              "
            >
              <h3>{{ group.key }}</h3>
              <el-icon :name="groupKeyName == group.key ? 'arrow-up' : 'arrow-down'"></el-icon>
            </div>
            <div v-show="groupKeyName == group.key" class="source-list">
              <span
                v-for="(item, itemIndex) in group.items"
                :key="itemIndex"
                class="drag-source"
                :position="null"
                draggable="true"
                :id="'drag-source-' + item.id"
                :info="JSON.stringify(item)"
              >
                {{ item.name }}
              </span>
            </div>
          </div>
          <!-- <template v-for="(item, index) in userList">
            <span
              :key="index"
              class="drag-source"
              :position="null"
              draggable="true"
              :id="'drag-source-' + item.id"
              :info="JSON.stringify(item)"
            >
              {{ item.name }}
            </span>
          </template> -->
        </div>
      </div>
      <div class="pricessDiv">
        <!-- <h3 style="">旅客名單</h3> -->
        <div class="process-container">
          <template>
            <div style="margin: 5px; margin-top: 0px">
              <el-radio-group v-model="seatType" @change="seatTypeHandle">
                <el-radio-button :label="1">左駕型式</el-radio-button>
                <el-radio-button :label="2">右駕型式</el-radio-button>
              </el-radio-group>
            </div>
            <div style="margin: 5px; margin-top: 10px">
              <el-button type="warning" @click="saveData" style="color: #4b4b4b" v-show="isCanSave"
                >儲存</el-button
              >
              <el-button @click="fatherDialogFormVisible(false)"> 取消 </el-button>
            </div>

            <!-- <el-button type="danger" @click="screenshot(true)">
              截圖
            </el-button> -->
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import { Message } from 'element-ui'

import {
  resetTravelSeat,
  getTravelTreavelersList,
  saveTravelSeat,
  getTravelSeat,
} from '@/api/travel'

export default {
  name: 'Seating',
  props: {
    travelID: {
      type: Number,
      default: null,
    },
    isCanSave: {
      type: Boolean,
      default: true,
    },
    travelName: {
      type: String,
      default: null,
    },
    fatherDialogFormVisible: {
      type: Function,
      default: () => null,
    },
    callback: {
      type: Function,
      default: () => null,
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    groupedArray() {
      const groupedData = {}

      this.userList.forEach(item => {
        const group = item.group || item.name.split('-')[0]
        if (group in groupedData) {
          groupedData[group].push(item)
        } else {
          groupedData[group] = [item]
        }
      })

      return Object.keys(groupedData).map(key => ({
        key,
        items: groupedData[key],
      }))
    },
  },
  watch: {
    isRefresh: {
      handler: function (newVal, oldVal) {
        let vm = this
        if (newVal) {
          let vm = this
          vm.seatInit().then(() => {
            vm.eventInit()
          })
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      loading: false,
      seatAry: [],
      noseat: [],
      noshow: [],
      userList: [],
      imageUrl: '',
      seatType: 1,
      groupKeyName: null,
    }
  },
  async created() {},
  async mounted() {},

  methods: {
    async seatTypeHandle() {
      let vm = this
      if (confirm(`更換座位型式將會重新設定旅客座位，請問是否確定要更換?`)) {
        this.loading = true

        let resp = await resetTravelSeat({
          travelID: vm.travelID,
          seatType: vm.seatType,
        })
        this.loading = false
        let travelID = vm.travelID
        let seatType = vm.seatType
        vm.callback(travelID, seatType)
        // vm.seatInit().then(() => {
        //   vm.eventInit();
        // });
      } else {
        vm.seatType = vm.seatType == 1 ? 2 : 1
      }
    },
    async screenshot(createImage) {
      document.getElementById('seatDiv').style.width = '500px'
      document.getElementById('leftContainer').style.width = '500px'

      //   let option = {
      //     x: 190,
      //     y: 20,
      //     width: 600,
      //     height: 1000,
      //   };
      let canvas = await html2canvas(this.$refs.capture)
      let link = document.createElement('a')
      link.href = canvas.toDataURL()
      this.imageUrl = canvas.toDataURL().replace('data:', '').replace(/^.+,/, '')

      //   .then((canvas) => {
      // this.$refs.addImage.append(canvas);
      if (createImage) {
        link.setAttribute('download', '圖片canvas.png')
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
      }

      const { body } = document
      const rect = body.getBoundingClientRect()
      const isMobile = rect.width - 1 < 992
      document.getElementById('seatDiv').style.width = '100%'
      document.getElementById('leftContainer').style.width = isMobile ? '100%' : '50%'
      //   });
    },
    async getTravelSeat() {
      let vm = this
      let data = await getTravelSeat({
        travelID: vm.travelID,
        seatType: vm.seatType,
      })
      vm.seatAry = data.data
    },
    async saveData() {
      if (!confirm(`確定儲存座位表?`)) {
        return false
      }
      let vm = this
      vm.loading = true
      await vm.screenshot(false)

      await saveTravelSeat({
        travelID: vm.travelID,
        seatType: vm.seatType,
        seatData: vm.seatAry,
        base64: vm.imageUrl,
      })
        .then(res => {
          Message({
            message: '座位設定完成',
            type: 'success',
            duration: 5 * 1000,
          })
          vm.fatherDialogFormVisible(false)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          console.log('finally')
          vm.loading = false
        })

      // await vm.seatInit();
    },
    async seatInit() {
      let vm = this
      vm.loading = true

      await vm.getTravelTreavelersList()
      //非座位
      vm.noseat = [
        [1, 3],
        [1, 4],
        [1, 5],
        [2, 3],
        [2, 4],
        [2, 5],
        [3, 3],
        [4, 3],
        [5, 3],
        [6, 3],
        [7, 1],
        [7, 2],
        [7, 3],
        [8, 3],
        [8, 4],
        [8, 5],
        [9, 3],
        [9, 4],
        [9, 5],
        [10, 3],
        [11, 3],
        [12, 3],
      ]

      vm.noShow = [
        [2, 5],
        [9, 5],
      ]

      let result = await getTravelSeat({
        travelID: vm.travelID,
        seatType: vm.seatType,
      })
      //產生座位資料
      vm.seatAry = result.data.seatData
      //   for (let i = 0; i < 13; i++) {
      //     vm.seatAry[i] = [];
      //     for (let j = 0; j < 5; j++) {
      //       vm.seatAry[i][j] = {
      //         position: [i, j],
      //         isSeat: true,
      //         user: null,
      //       };
      //     }
      //   }
      //過濾非座位
      for (let i = 0; i < vm.noseat.length; i++) {
        const element = vm.noseat[i]
        let x = element[0] - 1
        let y = element[1] - 1
        vm.seatAry[x][y].isSeat = false
      }

      //過濾不顯示
      for (let j = 0; j < vm.noShow.length; j++) {
        let ele = vm.noShow[j]
        let x_n = ele[0] - 1
        let y_n = ele[1] - 1
        try {
          vm.seatAry[x_n][y_n].display = false
        } catch (error) {
          debugger
        }
      }
      vm.loading = false
    },
    eventInit() {
      //人名
      let dragSource = document.querySelectorAll('.drag-source')
      dragSource.forEach(item => {
        item.addEventListener('dragstart', this.dragStart)
      })
      //右邊div
      let dragSourceContainer = document.querySelector('.source-container')
      dragSourceContainer.addEventListener('drop', this.dropped)
      dragSourceContainer.addEventListener('dragenter', this.cancelDefault)
      dragSourceContainer.addEventListener('dragover', this.cancelDefault)
      //左邊div
      let dropTarget = document.querySelectorAll('.seat')
      dropTarget.forEach(item => {
        item.addEventListener('drop', this.dropped)
        item.addEventListener('dragenter', this.cancelDefault)
        item.addEventListener('dragover', this.cancelDefault)
      })
    },
    async getTravelTreavelersList() {
      let users = await getTravelTreavelersList({
        travelID: this.travelID,
        seatType: this.seatType,
      })
      const formatData = users.data.map(formatItem => {
        formatItem.group = formatItem.name.split('-')[0]
        return formatItem
      })
      this.userList = formatData
    },
    findUser(info) {
      let userInfo = JSON.parse(info)
    },
    renderSeat(x, y, userInfo) {
      let vm = this
      let newSeat = []
      for (let i = 0; i < 13; i++) {
        newSeat[i] = []
        for (let j = 0; j < 5; j++) {
          newSeat[i][j] = {
            position: [i, j],
            isSeat: true,
            display: true,
            user:
              i == x && j == y ? userInfo : vm.seatAry[i][j].user ? vm.seatAry[i][j].user : null,
          }
        }
      }
      //過濾非座位
      for (let i = 0; i < vm.noseat.length; i++) {
        const element = vm.noseat[i]
        let x = element[0] - 1
        let y = element[1] - 1
        newSeat[x][y].isSeat = false
      }
      //過濾不顯示
      for (let j = 0; j < vm.noShow.length; j++) {
        let ele = vm.noShow[j]
        let x_n = ele[0] - 1
        let y_n = ele[1] - 1
        newSeat[x_n][y_n].display = false
      }
      vm.seatAry = []
      vm.seatAry = newSeat
    },
    filterUsers(info, position, newPosition) {
      //   alert(`position => ${position}  newPosition=>${newPosition}`);
      let vm = this
      let userInfo = JSON.parse(info)
      //從座位加入
      if (newPosition) {
        //要移動的目標位置
        let splitPosition = newPosition.split(',')
        let x = parseInt(splitPosition[0])
        let y = parseInt(splitPosition[1])

        //不能替換已排座位的旅客
        if (vm.seatAry[x][y].user) {
          vm.$message.error('請先移除座位上的旅客。')
          return
        }

        //被移動的原始位置
        if (position) {
          let splitBeforePosition = position.split(',')
          let x_b = parseInt(splitBeforePosition[0])
          let y_b = parseInt(splitBeforePosition[1])
          vm.seatAry[x_b][y_b].user = null
        }

        //產生座位資料
        vm.renderSeat(x, y, userInfo)
        //刪除未選
        let findIndex = vm.userList.findIndex(e => e.id === userInfo.id)
        if (findIndex != -1) {
          vm.userList.splice(
            vm.userList.findIndex(e => e.id === userInfo.id),
            1
          )
        }
      } else {
        if (position) {
          let splitPosition = position.split(',')
          let x = parseInt(splitPosition[0])
          let y = parseInt(splitPosition[1])
          //從座位移除
          vm.seatAry[x][y].user = null
          //加入userList清單
          let findIndex = vm.userList.findIndex(e => e.id === userInfo.id)
          if (findIndex == -1) {
            vm.userList.push(userInfo)
          }
        }
      }

      //重新渲染的dom需要重新註冊事件，不使用nextTick 會無法註冊事件
      this.$nextTick(() => {
        vm.eventInit()
      })
    },
    dragStart(e) {
      let info = e.target.getAttribute('info')
      let ps = e.target.getAttribute('position')
      let obj = { position: ps, info }
      let o = JSON.stringify(obj)
      e.dataTransfer.setData('obj', o)
    },
    dropped(e) {
      //   let obj = e.dataTransfer.getData("obj");
      var obj = JSON.parse(e.dataTransfer.getData('obj'))
      let position = obj.position
      let newPosition = e.target.getAttribute('position')
      let info = obj.info
      console.log('position=>' + position, 'newPosition=>' + newPosition)
      this.cancelDefault(e)
      if (
        e.target.classList.contains('drag-source') &&
        e.target.parentNode.classList.contains('source-container')
      ) {
        //左邊拉到右邊:拉到span內部
        let dragSourceContainer = document.querySelector('.source-container')
        // dragSourceContainer.appendChild(document.querySelector("#" + id));
        this.filterUsers(info, position, newPosition)
      } else if (
        e.target.classList.contains('drag-source') &&
        e.target.parentNode.classList.contains('seat')
      ) {
        //右邊拉到左邊:拉到span內部,更換調原本的元素回左邊
        var originalElement = e.target.parentNode.firstChild.id
        // e.target.parentNode.appendChild(document.querySelector("#" + id));
        var container = document.querySelector('.source-container')
        // container.appendChild(document.querySelector("#" + originalElement));
        this.filterUsers(info, position, newPosition)
      } else if (e.target.classList.contains('seat')) {
        //右邊拉到左邊:拉到div內部,檢查是否有子元素,無直接新增,有則先移除原本的元素回左邊再新增元素
        if (e.target.childElementCount == 0) {
          //   e.target.appendChild(document.querySelector("#" + id));
        } else {
          var originalElement = e.target.firstChild.id
          var container = document.querySelector('.source-container')
          //   container.appendChild(document.querySelector("#" + originalElement));
          //   e.target.appendChild(document.querySelector("#" + id));
        }
        this.filterUsers(info, position, newPosition)
      } else {
        //左邊拉到右邊:拉到div內部,直接新增
        // e.target.appendChild(document.querySelector("#" + id));
        this.filterUsers(info, position, newPosition)
      }
    },
    cancelDefault(e) {
      e.preventDefault()
      e.stopPropagation()
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.rowDiv {
  width: 60px;
  padding: 10px 0px;

  .leftrow {
    height: 50px;
    justify-content: flex-end;
    display: flex;
    align-items: center;
    padding-right: 2px;
  }

  .rightrow {
    height: 50px;
    justify-content: flex-start;
    display: flex;
    align-items: center;
    padding-left: 2px;
  }

  tr td {
    padding: 8px 0px;
    text-align: center;
    width: 45px;
  }
}

.seatDiv {
  border: 1px solid #c0c0c0;
  border-radius: 10px;
  padding: 10px 5px;
  width: 100%;

  .seat {
    background-color: #f8cf3e;
    border-radius: 10px;
    width: 100%;
    height: 50px;
    justify-content: center;
    display: flex;
    align-items: center;
    color: dimgray;
  }

  .noseat {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
  }

  .leftline {
    border-left: 5px solid #f7d185;
    padding-left: 8px;
  }

  .leftRowSpan {
    height: 100px;
    border-left: 5px solid #f7d185;
    padding-left: 8px;
  }

  //無跨行的
  .rightline {
    border-right: 5px solid #f7d185;
    justify-content: flex-end;
    padding-right: 8px;
  }

  //有跨行的
  .rightRowSpan {
    height: 100px;
    border-right: 5px solid #f7d185;
    justify-content: flex-end;
    padding-right: 8px;
  }

  tr {
    height: 50px;
  }

  tr td {
    width: 20%;
    padding: 8px;
  }
}

.seat-container {
  padding: 8px 3px;
}

.sourceDiv {
  width: 10%;
  text-align: center;
  margin-left: 50px;
}

.source-container {
  border-radius: 10px;
  border: 1px solid;
  height: 60%;
  padding: 8px;
  overflow: auto;
}

.source-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffe483;
  color: #000;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 12px;
  cursor: pointer;
}

.source-title > h3 {
  margin: 0;
  font-weight: 400;
  width: 80%;
  text-align: left;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;
}

.source-list {
  padding-bottom: 12px;
  display: flex;
  flex-direction: column;
}

.process-container {
  border-radius: 10px;
  height: 60%;
  padding: 8px;
  padding-top: 0px;
  overflow: auto;
}

.drag-source {
  margin: 8px 2px;
  color: dimgray;
  word-break: break-all;
}

.drag-source:hover {
  font-size: 18px;
}

[draggable='true'] {
  cursor: move;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.leftContainer {
  display: flex;
  justify-content: space-between;
  width: 50%;
}

//不大於900px
@media screen and (max-width: 900px) {
  .sourceDiv {
    // display: none;
    width: 90%;
    margin: 10px auto;
    text-align: center;
  }

  .seatDiv {
    flex: 1;

    .drag-source {
      line-height: 1rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }

  .seatDiv tr td {
    padding: 8px 0px;
  }

  .drag-source {
    //padding: 5px;
    margin: 5px;
    font-size: 14px;
  }

  .drag-source:hover {
    font-size: 14px;
  }

  .outsideDiv {
    flex-direction: column;

    .leftContainer {
      width: 100%;
    }
  }

  .source-container {
    min-height: 100px;
  }
}

@media screen and (min-width: 901px) {
  .source-container {
    display: flex;
    flex-direction: column;
  }
}
</style>
